import { useUser } from '@clerk/clerk-react';
export function useIsSuperAdmin() {
    const { user } = useUser();
    if (!user) {
        return false;
    }
    // Check if user's primary email domain ends with 'fluid-form.ai'
    const primaryEmail = user.primaryEmailAddress?.emailAddress;
    if (!primaryEmail) {
        return false;
    }
    return primaryEmail.endsWith('@fluid-form.ai');
}
